export default {
	path: '/warn-work-occur',
	redirect: '/warn-work-occur',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'warnWorkOccurHome',
			component: () => import('@/views/biz/WarnWorkOccur'),
		},
	],
};
